import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Charge } from '../Models/charge';
import { from, Observable } from 'rxjs';


@Injectable({
  providedIn: 'root'
})
export class StripeService {

  // Web Task URLs
  private webtask_discount_url = 'https://wt-0abace7df40ea939072b329aa74c0316-0.sandbox.auth0-extend.com/handle-discount';

  // Production URL
  // webtask_payment_url = 'https://wt-0abace7df40ea939072b329aa74c0316-0.sandbox.auth0-extend.com/webtask-stripe-payment';
  // Test URL
  private webtask_payment_url = 'https://wt-0abace7df40ea939072b329aa74c0316-0.sandbox.auth0-extend.com/stripe-payment';

  // Get Charge URL
  private webtask_get_charge_url = 'https://wt-0abace7df40ea939072b329aa74c0316-0.sandbox.auth0-extend.com/get-single-charge';

  // Get List of Charges URL
  private webtask_get_charge_list_url = 'https://wt-0abace7df40ea939072b329aa74c0316-0.sandbox.auth0-extend.com/get-number-of-charges';

  constructor(private http: HttpClient) {

  }

  processCharge(token, total_cost, email, attendees): Observable<any> {
    const promise = new Promise((resolve, reject) => {
      const command = {
        amount: total_cost * 100,
        currency: 'usd',
        description: 'Registration cost for ' + email.trim(),
        source: token,
        receipt_email: email.trim()
      };

      return this.http.post(this.webtask_payment_url, command).subscribe(
        (data: Charge) => {
          resolve(data);
          return data;
        },
        (error) => reject(error)
      );
    });

    return from(promise);
  }
}
